const Index = () => import('./index.vue');
const CreatePage = () => import('./_pages/create.vue');
const ViewPage = () => import('./_pages/view.vue');

export default [
    {
        path: '/accounts-transfer',
        component: Index
    },
    {
        path: '/new-account-transfer',
        component: CreatePage
    },
    {
        path: '/account-transfer/:id',
        component: ViewPage
    }
]